// extracted by mini-css-extract-plugin
module.exports = {"root":"DallasDialog_root__FsXZB","card":"DallasDialog_card__thPOR","backdrop":"DallasDialog_backdrop__xCeg8","closeButton":"DallasDialog_closeButton__3c6Sh"};